<template>
  <div id="app">
    
    <router-view/>
  </div>
</template>

<script>
import { queryIfLogin } from '@/assets/js/api/cloud'
export default {
  name: 'app',
  computed: {
    isLoginIng () {
      return this.$store.state.user.isLoginIng
    },
    needLogin () {
      return this.$store.state.user.needLogin
    },
  },
  created () {
    this.$store.dispatch('user/getUserInfo')
    // if (!this.needLogin) {
    //   queryIfLogin().then(res => {
    //     this.$store.commit('user/setNeedLogin', true)
    //     this.$store.dispatch('user/getUserInfo')
    //   })
    // }
  },
}
</script>

<style>
body, html {
  padding: 0;
  margin: 0;
}

html {
  overflow-y: scroll;
}
</style>
